import { AuthenticationService } from '../shared/services/authentication.service';
import { Injectable } from '@angular/core';
import {MENU_ITEMS, MENU_ITEMS_IGNORED} from './pages-menu';
import { NgxSpinnerService } from 'ngx-spinner';
import { HeaderService } from '../@theme/components/header/header.service';
import { HttpService } from '../shared/services/http/http-client.service';
import { NotificationsService } from 'angular2-notifications';

@Injectable({
    providedIn: 'root',
   })
export class PagesService {
  headerInformation = null;

  roles =  [];
  constructor(
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService,
  ) { }



  reloadMenus() {
    this.roles = [];
    this.setHidden(MENU_ITEMS);
  }

  fillRoles() {
    return this.authService
    .getRoles()
    .toPromise();
  }

  async setHidden(menus) {
    if (this.roles == null || this.roles.length === 0) {
      this.roles = await this.fillRoles();
    }
    await  menus.forEach(menu => {
      if (menu.data) {
        menu.data.roles.some( menuRole =>  this.roles.indexOf(menuRole) >= 0)

        const hasRole = menu.data.roles.some( menuRole =>  this.roles.indexOf(menuRole) >= 0);

        if (hasRole) {

          menu['hidden'] = false;
        }else {

          menu['hidden'] = true;
        }

        const menusIgnore = MENU_ITEMS_IGNORED;
        if (menu.link) {
          const ignore = menusIgnore.some(menuIgnore => menu.link === menuIgnore.link);
          if (ignore) {
            menu['hidden'] = true;
          }
        }

        if (menu['children'] && menu['children'].length > 0) {
          this.setHidden(menu['children']);
        }
      }
    });
    this.spinner.hide();
  }

}
